import React, { createContext, useState } from "react"

export const GlobalContext = createContext(null)

export const GlobalContextProvider = ({ children }) => {
    const [salesOrgination, setSalesOrgination] = useState([])
    const [languages, setLanguages] = useState([])
    const [isUserManagement, setIsUserManagement] = useState(false)
    const [isProductsManagement, setIsProductsManagement] = useState(false)
    const [selectedLanguage, setselectedLanguage] = useState("en-us")
    const[finishedGoodID, setFinishedGoodID]=useState()
    const[enabledApi, setEnabledApi]=useState(false)
    const [globalLanguageChange, setGlobalLanguageChange]= useState()
    const [basketCount, setBasketCount]= useState(0)
    const [tabValue, setTabValue]= useState(1)
    const [getServiceCenterByCountryId, setGetServiceCenterByCountryId]= useState([])
    const [hamburger, setHamburger]= useState(false)
    const [userCountryDetails, setUserCountryDetails]= useState([])
    const [lastFilterAppliedWarranty, setLastFilterAppliedWarranty]= useState()

    const obj = {
        globalLanguageChange: globalLanguageChange,
        setGlobalLanguageChange: setGlobalLanguageChange,
        salesOrgination: salesOrgination,       
        setSalesOrgination: setSalesOrgination,
        setLanguages: setLanguages,
        languages: languages,
        isUserManagement:isUserManagement,
        setIsUserManagement: setIsUserManagement,
        isProductsManagement: isProductsManagement,
        setIsProductsManagement: setIsProductsManagement,
        selectedLanguage: selectedLanguage,
        setselectedLanguage: setselectedLanguage,
        setFinishedGoodID: setFinishedGoodID,
        finishedGoodID:finishedGoodID,
        setEnabledApi:setEnabledApi,
        enabledApi:enabledApi,
        setTabValue:setTabValue,
        tabValue:tabValue,
        basketCount:basketCount,
        setBasketCount:setBasketCount,
        getServiceCenterByCountryId:getServiceCenterByCountryId,
        setGetServiceCenterByCountryId: setGetServiceCenterByCountryId,
        hamburger:hamburger,
        setHamburger:setHamburger,
        userCountryDetails: userCountryDetails, 
        setUserCountryDetails: setUserCountryDetails,
        lastFilterAppliedWarranty:lastFilterAppliedWarranty,
        setLastFilterAppliedWarranty: setLastFilterAppliedWarranty
    }
    return <GlobalContext.Provider value={ obj }>{ children }</GlobalContext.Provider>
}
